import { memo, useMemo } from "react";
import { StickyNote } from "./StickyNote";
import type { NotedObject, StickyNotesProps } from "./types";

export const StickyNotes = memo(function StickyNotes({
  objects,
  zoomLevel,
  panOffset,
  shouldAnimateTransition,
  onSelectNote,
  hiddenNoteObjectId,
}: StickyNotesProps) {
  // Plans hold thousands of markers and few notes; only the noted ones are walked on every pan.
  const notedObjects = useMemo(() => {
    const noted: NotedObject[] = [];
    for (const object of objects) {
      if (object.note === undefined || object.note === null) continue;
      noted.push({
        id: object.id,
        note: object.note,
        rgb: object.rgb,
        x: object.bbox.x2,
        y: object.bbox.y1,
      });
    }
    return noted;
  }, [objects]);

  if (notedObjects.length === 0) return null;

  return (
    <div className="pointer-events-none absolute inset-0 overflow-hidden">
      {notedObjects.map((noted) =>
        noted.id === hiddenNoteObjectId ? null : (
          <StickyNote
            key={noted.id}
            objectId={noted.id}
            note={noted.note}
            rgb={noted.rgb}
            anchorX={panOffset.x + noted.x * zoomLevel}
            anchorY={panOffset.y + noted.y * zoomLevel}
            shouldAnimateTransition={shouldAnimateTransition}
            onSelectNote={onSelectNote}
          />
        ),
      )}
    </div>
  );
});
